import React, {useState}from "react";
import PrimaryButton from "./components/Buttons/PrimaryButton";
// import { forgotPassword } from "../../redux/slices/auth";
import { showToastError, showToastSuccess } from "./utils/showToasify";
// import { useDispatch } from "react-redux";
import { getAuth, sendPasswordResetEmail } from "firebase/auth";

function ForgotPassword (){
    const auth = getAuth();
    const [email, setEmail] = useState("");
    /* eslint-disable-next-line no-useless-escape */
    const EMAIL_VALIDATOR = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    //const dispatch = useDispatch();

    const handleSubmit = async () => {
        if (email.trim() === "") {
          showToastError("Please fill all the fields");
        } else if (!EMAIL_VALIDATOR.test(email)) {
          showToastError("Please enter valid email");
        }
        else{
         try {
                await sendPasswordResetEmail(auth,email); // Sends the reset link email
                showToastSuccess(`Password reset email sent to ${email}`);
                                // navigate('/checkEmail');
            } catch (error) {
                // console.error('Error sending email reset link:', error);
                showToastError(error.message);
            }
        }
    }
    return(
        <div>
              <img src="/peeqlogo.svg" alt="Peeq Logo" className="pl-20 pt-10 m-auto" />
              
              <div className="flex justify-center">
              <img src="/Email.svg" alt="Peeq Logo" className="pl-20 pt-10" />
              </div>
              <div className="emailcontent"> 
              
               <div className="emailinputs m-auto">
               <div className="title"> Forgot Password</div>
                 <p>Where do we send your one-time password?</p>   
                 <div className="email-container">
                 <img src="/emailicon.svg" alt="email Logo" className="email-toggle" />
                    <input
                    className= "w-full outline-none border-none h-12 rounded-[1rem] pl-10 bg-[#F4F5F5] placeholder:text-[#94979F] font-normal text-[0.90rem] md:text-[1rem] placeholder:text-[0.90rem] md:placeholder:text-[1rem]"
                    type="email"
                    placeholder="Enter Your Email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}/>
                     
                 </div>
                 
                <div className="emailbottom">
                <p>Don't have an account?<span> Sign Up</span></p>
                 <div className="submit-button-container">
            <PrimaryButton variant="full" text="Next" onClick={handleSubmit} />
            </div>
            </div>
            </div> 
                </div>
        </div>
    )
}

export default ForgotPassword;